import { MdClose } from "react-icons/md";

interface OfferDeleteModalProps {
    onDelete: () => void;
    onClose: () => void;
}

export default function OfferDeleteModal({ onDelete, onClose }: OfferDeleteModalProps) {
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
                >
                    <MdClose size={24} />
                </button>

                {/* Title */}
                <h2 className="text-2xl font-bold text-[#FF7A00] mb-2">Delete Offer</h2>
                <p className="text-gray-600 mb-6">
                    Are you sure you want to delete this offer? This action cannot be undone.
                </p>

                {/* Actions */}
                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-[#FF7A00] text-white hover:bg-orange-600"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onDelete}
                        className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}
